import { Button as _Button } from '@studio/design-system/button';
import { Icon } from '@studio/design-system/icon';
import type { ReactElement } from 'react';
import { isElement } from 'react-is';
import type { ButtonProps } from './types.js';

/** Footer `<Button>` component. */
export const Button = ({
  children,
  icon,
  label,
  variant = 'secondary',
  ...props
}: ButtonProps): ReactElement => (
  <_Button size='lg' variant={variant} {...props}>
    {!!icon && (isElement(icon) ? icon : <Icon icon={icon} />)}
    {label}
    {children}
  </_Button>
);
